import PropertyDetails from './PropertyDetails';

export default PropertyDetails;
